import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-addendums',
  templateUrl: './addendums.component.html',
  styleUrls: ['./addendums.component.scss']
})
export class AddendumsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
